/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';
import Store from '../store/store';

export const userWelcomed = (dispatch) => {
  dispatch({ type: Types.USER_WELCOMED });
};
// update state based on current org teams/products wall
export const showingOrgWall =
  ({ level, showingProducts }) =>
  (dispatch) =>
    dispatch({
      level,
      showingProducts,
      type: Types.SHOWING_ORG_WALL,
      fullState: Store.getState()
    });

// update state based on current list wall
export const showingListWall = (level) => (dispatch) =>
  dispatch({
    level,
    fullState: Store.getState(),
    type: Types.SHOWING_LIST_WALL
  });

export const tourInactive = () => {
  const { activeTour } = Store.getState().tourReducer;
  const tour = Store.getState().tourReducer[activeTour];
  tour.hide();
  const stepOptions = tour.getCurrentStep()?.options;
  if (stepOptions?.dispatch_on?.done) {
    Store.dispatch(stepOptions.dispatch_on.done);
  }
  return (dispatch) => dispatch({ type: Types.TOUR_INACTIVE });
};

export const tourActive = () => {
  const { activeTour, currentStep } = Store.getState().tourReducer;
  const tour = Store.getState().tourReducer[activeTour];
  if (currentStep) tour.show(currentStep);
  else tour.start();
  return (dispatch) => dispatch({ type: Types.TOUR_ACTIVE });
};

export const toggleTourActive = () => {
  const { showing } = Store.getState().tourReducer;
  if (showing) return tourInactive();
  return tourActive();
};

export const showingTourStep = (id) => (dispatch) => {
  const currentState = Store.getState().tourReducer;
  const { activeTour } = currentState;
  const tour = currentState[activeTour];

  const currentStepIndex = tour.steps.findIndex(
    (ts) => ts.id === currentState.currentStep
  );
  if (
    currentStepIndex > -1 &&
    currentState.currentStep !== tour.getCurrentStep().id
  ) {
    const stepOptions = tour.steps[currentStepIndex].options;
    if (stepOptions.dispatch_on?.done) {
      Store.dispatch(stepOptions.dispatch_on.done);
    }
  }
  dispatch({ id, type: Types.SHOWING_TOUR_STEP });
};

export const closingTour = () => (dispatch) =>
  dispatch({ type: Types.CLOSING_TOUR });

export const updateTourState = (dispatch) =>
  dispatch({ fullState: Store.getState(), type: Types.UPDATE_TOUR_STATE });
